/**
 * Quote add-ons: product metadata and BI rider mapping (NSure).
 */

/** Order: ADB, CI (row 1), ADD, ADD+ (row 2). */
export const RIDERS_DATA = [
  {
    id: "accidental-death",
    name: "INL Accidental Death Benefit",
    premium: 252,
    minCover: 50_000,
    maxCover: 10_000_000,
  },
  {
    id: "critical-illness",
    name: "INL Critical Illness",
    premium: 131,
    minCover: 100_000,
    maxCover: 5_000_000,
  },
  {
    id: "accidental-death-disability",
    name: "INL Accidental Death and Disability",
    premium: 200,
    minCover: 50_000,
    maxCover: 10_000_000,
  },
  {
    id: "accidental-death-disability-plus",
    name: "INL Accidental Death and Disability Plus",
    premium: 180,
    minCover: 50_000,
    maxCover: 10_000_000,
  },
];

export const ADD_PLUS_CI_EXCLUSIVE_TITLE =
  "Accidental Death and Disability Plus and Critical Illness cannot be opted together. Choose one.";

export const BI_RIDER_ID_BY_FRONTEND_ID = {
  "accidental-death": 32007,
  "accidental-death-disability": 32008,
  "accidental-death-disability-plus": 32009,
  "critical-illness": 32011,
};

export const BI_RIDER_NAME_BY_FRONTEND_ID = {
  "accidental-death": "Accidental Death Benefit Rider",
  "accidental-death-disability": "Accidental Death and Disability Rider",
  "accidental-death-disability-plus":
    "Accidental Death and Disability Plus Rider",
  "critical-illness": "Critical Illness Rider",
};

/**
 * Per-rider default (fallback) premium amounts shown on the Add-on card
 * before the dynamic API premium arrives. Values are in INR for the
 * Yearly (Annual) frequency and are scaled down for other frequencies
 * (Monthly / Quarterly / Half-Yearly) at render time. The dynamic
 * calculation flow is unchanged — once an API premium is available it
 * replaces these fallbacks.
 */
export const RIDER_FALLBACK_YEARLY_PREMIUM = {
  "accidental-death": 32.5,
  "accidental-death-disability": 47.5,
  "accidental-death-disability-plus": 55,
  "critical-illness": 62.92,
};
